import { template as template_99a2db0194774c9eb83201dd389f76fb } from "@ember/template-compiler";
import { service } from '@ember/service';
import Component from '@glimmer/component';
import styles from './loading-skeleton.module.scss';
export default class RequestStepsLoadingSkeleton extends Component {
    @service
    requestPreloader;
    get skeletonName() {
        return this.requestPreloader.componentNameForStep(this.args.step);
    }
    get loadingComponent() {
        return this.requestPreloader.componentForStep(this.args.step, this);
    }
    static{
        template_99a2db0194774c9eb83201dd389f76fb(`
    <div class="{{styles.component}} skeleton-{{this.skeletonName}}" ...attributes>
      {{#if @step}}
        <this.loadingComponent @hasSignInBox={{@hasSignInBox}} />
      {{/if}}
    </div>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
